import { forwardRef, useImperativeHandle, useRef } from 'react';
import { Row, Col } from 'src/componentes/grid';
import ContentManager from 'src/componentes/content-manager';
import FormularioGlobalPreviewDialog from 'src/componentes/formulario-global/FormularioGlobalPreviewDialog';
import FormularioPesquisaClimaBuilder from '../FormularioPesquisaClimaBuilder';

const FormularioPesquisaClimaTabContent = forwardRef(
  (
    {
      active,
      disabled,
      entidadeId,
      formularioId,
      onBranchingChange,
      randomizarPerguntas,
    },
    ref
  ) => {
    const builderRef = useRef();

    useImperativeHandle(ref, () => ({
      validateFormularioGlobal: () =>
        builderRef.current?.validateFormularioGlobal(),
      saveFormularioGlobal: (savedEntidadeId) =>
        builderRef.current?.saveFormularioGlobal(savedEntidadeId),
      getPerguntasCount: () => builderRef.current?.getPerguntasCount?.(),
    }));

    const handlePreview = () => {
      ContentManager.addContent(
        <FormularioGlobalPreviewDialog
          formulario={builderRef.current?.getFormularioGlobal?.()}
        />
      );
    };

    return (
      <Row>
        <Col md={12}>
          <FormularioPesquisaClimaBuilder
            active={active}
            disabled={disabled}
            entidadeId={entidadeId}
            formularioId={formularioId}
            onPreview={handlePreview}
            onBranchingChange={onBranchingChange}
            randomizarPerguntas={randomizarPerguntas}
            ref={builderRef}
          />
        </Col>
      </Row>
    );
  }
);

export default FormularioPesquisaClimaTabContent;
